var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecondWhale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 366,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#secondWhale_svg__clip0_632_7728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.712 66.255H31.559c-8.346 0-15.11 6.765-15.11 15.11 0 8.346 6.764 15.111 15.11 15.111h74.153c8.345 0 15.111-6.765 15.111-15.11 0-8.346-6.766-15.11-15.111-15.11z",
    fill: "#C3DCF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.06 101.029c-.438 6.224 2.571 12.443 7.479 16.221a18.244 18.244 0 004.609 2.571c.845.322 1.209-1.031.374-1.348-5.379-2.044-9.405-6.993-10.688-12.554a16.56 16.56 0 01-.374-4.89c.066-.9-1.334-.895-1.4 0z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.998 23h-84.887C221.765 23 215 29.765 215 38.11c0 8.346 6.765 15.111 15.111 15.111h84.887c8.346 0 15.111-6.765 15.111-15.11 0-8.346-6.765-15.111-15.111-15.111z",
    fill: "#9EE1DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.387 58.474c1.731 7.367.014 15.335-4.33 21.497a25.527 25.527 0 01-4.287 4.684c-.686.588.308 1.572.989.99 6.028-5.146 9.545-12.97 9.694-20.864.042-2.244-.2-4.492-.713-6.68-.206-.877-1.554-.504-1.349.373h-.004z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.282 92h-59.524c-6.497 0-11.765 5.175-11.765 11.559 0 6.384 5.268 11.559 11.765 11.559h59.524c6.498 0 11.766-5.175 11.766-11.559 0-6.384-5.268-11.559-11.766-11.559z",
    fill: "#C3DCF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.375 120.312c-.518 5.64-2.519 11.107-5.71 15.782-3.191 4.675-7.465 8.304-12.428 10.809a33.441 33.441 0 01-8.734 2.963c-.881.168-.508 1.52.374 1.348 5.659-1.087 10.986-3.62 15.451-7.259 4.525-3.695 8.001-8.556 10.156-13.977 1.232-3.093 1.987-6.349 2.295-9.666.084-.896-1.315-.891-1.399 0h-.005z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.123 123.866H15.111C6.765 123.866 0 130.631 0 138.976c0 8.346 6.765 15.111 15.11 15.111h49.013c8.345 0 15.11-6.765 15.11-15.111 0-8.345-6.765-15.11-15.11-15.11z",
    fill: "#9EE1DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.967 150.569c2.039 6.051 7.492 10.665 13.711 11.962 1.764.368 3.574.471 5.37.27.886-.098.895-1.502 0-1.399-5.855.658-11.864-2.081-15.386-6.779a15.91 15.91 0 01-2.347-4.422c-.284-.849-1.637-.485-1.348.373v-.005z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.48 178.961H60.476c-8.346 0-15.11 6.766-15.11 15.111s6.764 15.111 15.11 15.111H79.48c8.345 0 15.11-6.766 15.11-15.111s-6.765-15.111-15.11-15.111z",
    fill: "#C3DCF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.501 207.508c3.662 3.699 9.167 5.267 14.234 4.082.877-.205.503-1.554-.374-1.348-4.581 1.073-9.568-.383-12.87-3.723-.635-.639-1.624.35-.99.989zM151.86 171.112c16.377 0 29.654-13.277 29.654-29.655s-13.277-29.654-29.654-29.654c-16.378 0-29.655 13.276-29.655 29.654s13.277 29.655 29.655 29.655zM140.812 345.582s-10.563 21.829-11.768 44.427c7.24 7.24 127.364 2.662 127.364 2.662s-12.228-32.818-27.026-47.089c-18.631-11.676-88.57 0-88.57 0z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.612 57.433s33.798 14.689 34.292 68.766c-7.784-21.585-29.672-36.727-29.672-36.727l-22.146-1.205-20.682 63.946s-55.384-35.346-22.892-82.368c21.26-30.767 61.1-12.412 61.1-12.412z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.289 145.726s-1.808 28.181 15.283 42.829c-11.885 19.761-36.585-.134-36.585-.134l-10.387 7.206s7.106-32.199-17.258-69.319",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.289 145.726s-1.808 28.181 15.283 42.829c-11.885 19.761-36.585-.134-36.585-.134l-10.387 7.206s7.106-32.199-17.258-69.319",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.93 149.367s16.698 13.501 32.827 5.273c25.72-13.124-1.306-81.179-1.306-81.179l-16.899-7.131-15.141 11.751-19.987 15.903-13.668 21.05",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.93 149.367s16.698 13.501 32.827 5.273c25.72-13.124-1.306-81.179-1.306-81.179l-16.899-7.131-15.141 11.751-19.987 15.903-13.668 21.05",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.871 100.528s-5.725-5.365-10.629-.468c-8.412 8.395 7.29 25.913 7.29 25.913l-6.135 5.733M196.177 102.111s-5.951 4.821-15.384 10.63",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.676 112.912c1.23-.147 2.052-1.718 1.837-3.508-.215-1.79-1.386-3.121-2.616-2.974-1.23.148-2.053 1.719-1.838 3.509.215 1.79 1.387 3.121 2.617 2.973zM194.297 117.153c1.23-.148 2.053-1.718 1.838-3.508-.215-1.79-1.387-3.122-2.617-2.974-1.23.148-2.053 1.719-1.838 3.509.215 1.79 1.387 3.121 2.617 2.973zM210.844 72.055s-10.982 38.426-45.733 49.048c-24.39 3.297-26.524-.544-26.524-.544l-2.269-12.162 19.603-27.57 19.786-11.651 14.245-3.549 14.89-.77 6.002 7.19v.008z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.299 120.425c-5.541-7.927-14.455-11.266-19.912-7.458-5.457 3.808-5.39 13.333.151 21.26 5.541 7.926 14.455 11.265 19.912 7.457",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.299 120.425c-5.541-7.927-14.455-11.266-19.912-7.458-5.457 3.808-5.39 13.333.151 21.26 5.541 7.926 14.455 11.265 19.912 7.457",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.047 128.895s-7.332-10.965-15.183-6.186l15.183 6.186z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.047 128.895s-7.332-10.965-15.183-6.186",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.571 135.315s-8.763-4.997-7.031-13.526l7.031 13.526z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.571 135.315s-8.763-4.997-7.031-13.526",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.793 357.684s-.595 24.457 5.373 34.208M170.663 379.238c1.007-.104 1.476-3.547 1.047-7.69-.429-4.142-1.593-7.416-2.6-7.312-1.007.104-1.475 3.547-1.046 7.69.428 4.143 1.592 7.417 2.599 7.312zM207.695 359.853s3.834 12.931 19.895 20.037",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.573 164.081s18.062 8.379 37.656-2.268l5.264 10.981 30.894 12.547a53.904 53.904 0 0133.471 45.884c3.18 42.083 1.557 108.473-40.243 109.344l-.234 5.021c-45.473 21.561-88.57 0-88.57 0l-6.554-35.856-.862 5.114a145.269 145.269 0 01-17.367 48.311l-17.836 30.943H60l33.212-71.796 18.07-99.677a44.574 44.574 0 0119.201-26.608L161.786 176l.795-11.919h-.008z",
    fill: "#008AE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.278 241.26l2.762 4.461s-12.739 35.405 5.215 64.013l3.431 18.799M172.876 296.543s6.47 13.157 25.026 14.011",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.573 241.26l-1.532-14.112s22.289-34.124 11.91-36.358c2.227-5.399-3.306-7.148-3.306-7.148s-.946-5.876-7.072-4.604c.535-6.83 8.311-31.044 8.311-31.044s-5.081-4.201-9.843 8.027c-4.762 12.228-6.512 24.926-6.512 24.926l-1.531-2.227a1.576 1.576 0 00-2.746.268c-1.155 2.653-3.005 6.621-4.612 8.621-2.536 3.172-17.149 26.516-6.829 40.326l2.536 21.594",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.573 241.26l-1.532-14.112s22.289-34.124 11.91-36.358c2.227-5.399-3.306-7.148-3.306-7.148s-.946-5.876-7.072-4.604c.535-6.83 8.311-31.044 8.311-31.044s-5.081-4.201-9.843 8.027c-4.762 12.228-6.512 24.926-6.512 24.926l-1.531-2.227a1.576 1.576 0 00-2.746.268c-1.155 2.653-3.005 6.621-4.612 8.621-2.536 3.172-17.149 26.516-6.829 40.326l2.536 21.594",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.646 253.371l-9.449-15.627-26.332 8.931 3.541 16.003",
    fill: "#008AE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.204 293.973l-34.007-56.229-26.332 8.931s14.497 78.317 41.749 93.893M205.617 198.489s-2.812.411-3.607-1.18c-2.972-5.926 6.428-20.272 13.801-18.271",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.138 203.11s-2.812.41-3.607-1.18c-2.971-5.926 6.428-20.272 13.802-18.272",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.941 191.125c-7.382-2.001-16.137 8.821-13.166 14.756.201.393.528.669.896.853 1.239.611 2.737-.05 3.264-1.33.653-1.582 1.967-4.026 4.411-6.018M196.754 226.872s-2.034-9.717 10.153-15.961M204.537 180.947l.904 2.528M202.011 197.309l-1.524 3.65M162.574 164.081s15.702 8.563 37.656-2.268M227.531 245.243v13.25",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.551 111.159l-3.833 4.226s-4.838-6.779-12.346 3.75c.251-5.507 4.043-8.571 4.277-8.721.234-.151 6.964-3.892 6.964-3.892",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.717 115.385s-4.26-7.315-12.345 3.75l-3.792-.443",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.258 114.85s4.327-9.701 9.901-4.311c-1.439-4.578-2.444-5.951-2.444-5.951l-5.398.435-2.059 3.507-1.758 2.319 1.758 3.992v.009z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.081 113.486s5.114-8.538 10.002-2.495l2.084-1.489M210.163 137.607l-6.554 3.851",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.857 114.85s6.947 18.439 23.988 32.45",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "secondWhale_svg__clip0_632_7728"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h336v366H0z"
  })))));
}
export default __webpack_public_path__ + "static/secondWhale.c8daeb6e.svg";
export { SvgSecondWhale as ReactComponent };